import { z } from "zod";
import { Id, IsoDateTime } from "./common";

/**
 * Initial role set per
 * designs/asset_monitoring_mvp_domain_data_model.md §5.2.
 *
 * Adding a role key here is a contract change: backend permission map
 * (`backend/src/shared/permissions.ts`) and any UI role pickers must
 * be updated in the same change.
 */
export const RoleKey = z.enum([
  "PlatformAdmin",
  "TenantAdmin",
  "Manager",
  "Operator",
  "Viewer",
  "IntegrationAdmin",
  // End-user field roles (mobile app)
  "FieldWorker",
  "FieldManager",
  // End-user portal roles (web customer portal)
  "PortalViewer",
  "PortalOperator",
]);
export type RoleKey = z.infer<typeof RoleKey>;

export const ROLE_KEYS: readonly RoleKey[] = RoleKey.options;

export const RoleScopeType = z.enum([
  "Platform",
  "Tenant",
  "Site",
  "Building",
  "Asset",
]);
export type RoleScopeType = z.infer<typeof RoleScopeType>;

export const RoleAssignmentStatus = z.enum(["Active", "Revoked"]);
export type RoleAssignmentStatus = z.infer<typeof RoleAssignmentStatus>;

export const RoleAssignment = z.object({
  roleAssignmentId: Id,
  tenantId: Id,
  userId: Id,
  roleKey: RoleKey,
  scopeType: RoleScopeType,
  scopeId: Id.nullable(),
  status: RoleAssignmentStatus,
  createdAt: IsoDateTime,
  createdBy: Id.nullable(),
  revokedAt: IsoDateTime.nullable(),
  revokedBy: Id.nullable(),
});
export type RoleAssignment = z.infer<typeof RoleAssignment>;

export const RoleAssignmentCreateInput = z.object({
  roleKey: RoleKey,
  scopeType: RoleScopeType.default("Tenant"),
  scopeId: Id.nullable().optional(),
});
export type RoleAssignmentCreateInput = z.infer<typeof RoleAssignmentCreateInput>;
